/**
 * PeopleTimesheets Component
 * 
 * Displays timesheets for a specific person.
 * Reuses AllTimesheetsTable component but with filtered data for the person.
 */

import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import {
    AllTimesheetsTable,
    Pagination
} from '../../../components/MyAllTimesheets/components';

const PeopleTimesheets = () => {
    const { peopleId } = useParams();
    
    const [show, setShow] = useState(false);
    const [showFilter, setShowFilter] = useState(false);

    // Handler functions
    const handleShow = () => setShow(true);
    const handleMoveOrCopyShow = () => {
        // TODO: Implement move/copy functionality
        console.log('Move/Copy show');
    };
    const handleLogTimeShow = (data) => {
        // TODO: Implement log time functionality
        console.log('Log time:', data);
    };
    const handleHistoryShow = () => {
        // TODO: Implement history view
        console.log('Show history');
    };
    const handleQuickSubtasksShow = () => {
        // TODO: Implement quick subtasks
        console.log('Show quick subtasks');
    };
    const handleDeleteShow = () => {
        // TODO: Implement delete functionality
        console.log('Show delete confirmation');
    };
    const handleEstimateTimeShow = () => {
        // TODO: Implement time estimation
        console.log('Show time estimation');
    };

    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = 100; // This would come from API filtered by peopleId
    const totalPages = Math.ceil(totalItems / pageSize);

    // NOTE: In real implementation, you would filter timesheets by peopleId
    // For now, using same data structure but filtered
    console.log('Loading timesheets for person:', peopleId);

    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Timesheets
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button variant='primary'
                                className='btn-sm text-nowrap'
                                onClick={handleShow}
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Logs
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <AllTimesheetsTable
                        onEdit={handleShow}
                        onMoveOrCopy={handleMoveOrCopyShow}
                        onLogTime={handleLogTimeShow}
                        onViewHistory={handleHistoryShow}
                        onAddSubtasks={handleQuickSubtasksShow}
                        onView={() => {}} // TODO: Implement view handler
                        onDuplicate={() => {}} // TODO: Implement duplicate handler
                        onDelete={handleDeleteShow}
                        onEstimateTime={handleEstimateTimeShow}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>
        </>
    );
};

export default PeopleTimesheets;
